import { DatalayerDataInterface } from '../interfaces/data-layer-data.interface';

globalThis.dataLayer = globalThis.dataLayer ?? [];

export const addToDataLayer = (data: DatalayerDataInterface) => globalThis.dataLayer.push(data);
